import React, { useEffect, useRef, useState } from "react";
import jackpotSvgUrl from "./jackpot.svg";

// Cache so we don't refetch for every mount.
let cachedSvgText = null;
let cachedSvgPromise = null;

function loadJackpotSvg() {
  if (cachedSvgText) return Promise.resolve(cachedSvgText);
  if (cachedSvgPromise) return cachedSvgPromise;

  cachedSvgPromise = fetch(jackpotSvgUrl)
    .then((r) => {
      if (!r.ok) throw new Error(`Failed to load jackpot.svg: ${r.status}`);
      return r.text();
    })
    .then((t) => {
      cachedSvgText = t;
      return t;
    });

  return cachedSvgPromise;
}

const JackpotSVG = ({ animOn = true, restartOnPlay = false }) => {
  const hostRef = useRef(null);
  const prevAnimOnRef = useRef(animOn);

  const [svgText, setSvgText] = useState(cachedSvgText || "");
  const [instanceKey, setInstanceKey] = useState(0);

  // Load SVG once (cached)
  useEffect(() => {
    let cancelled = false;

    loadJackpotSvg()
      .then((t) => {
        if (!cancelled) setSvgText(t);
      })
      .catch((err) => {
        // eslint-disable-next-line no-console
        console.error(err);
        if (!cancelled) setSvgText("");
      });

    return () => {
      cancelled = true;
    };
  }, []);

  // Restart full SVG animation sequence on false -> true
  useEffect(() => {
    const prev = prevAnimOnRef.current;

    if (restartOnPlay && !prev && animOn) {
      setInstanceKey((k) => k + 1);
    }

    prevAnimOnRef.current = animOn;
  }, [animOn, restartOnPlay]);

  // Toggle CSS + SMIL animation state
  useEffect(() => {
    const host = hostRef.current;
    if (!host) return;

    const svg = host.querySelector("svg");
    if (!svg) return;

    svg.classList.toggle("is-off", !animOn);

    // Pause / resume SMIL (<animate>, <animateTransform>) when supported
    try {
      if (!animOn && typeof svg.pauseAnimations === "function") {
        svg.pauseAnimations();
      } else if (animOn && typeof svg.unpauseAnimations === "function") {
        svg.unpauseAnimations();
      }
    } catch {
      // ignore
    }
  }, [animOn, svgText, instanceKey]);

  return (
    <span
      key={instanceKey}
      ref={hostRef}
      className="jackpot-svg-inline"
      // eslint-disable-next-line react/no-danger
      dangerouslySetInnerHTML={{ __html: svgText }}
    />
  );
};

export default JackpotSVG;
